import { Link } from "react-router-dom";
import { articles } from "@/mocks/categories";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function ArticleGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <ScrollToTop />
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="text-xs tracking-widest uppercase text-foreground-400 font-medium">Our Blog</span>
          <h2 className="mt-2 text-2xl md:text-4xl font-heading text-foreground-900 leading-tight">
            Latest <span className="font-script text-accent-500">acbuyspreadsheet</span> Guides
          </h2>
          <p className="mt-2 text-sm text-foreground-500">Expert guides, comparisons, and tutorials to master your buying workflow</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-all cursor-pointer"
            >
              <div className="h-48 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-bold text-foreground-800 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-accent-500">
                  Read More <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}